<template>
  <div class="delete-row">
    <button
      @click="visibleDropdown = true"
      class="delete-row__btn" type="button">
      <i class="fa fa-trash"></i>
    </button>
    <div class="delete-row__confirm-dialog confirm-delete-dialog" v-if="visibleDropdown">
      <div class="confirm-delete-dialog__header">
        <slot name="header"></slot>
        <button
          @click="visibleDropdown = false"
          type="button" class="close close-btn dropdown-help-header__close-btn" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="confirm-delete-dialog__body">
        <slot name="body"></slot>
      </div>
      <div class="confirm-delete-dialog__actions">
        <button
          type="button"
          @click="deleteConfirm"
          class="btn--inverse-primary confirm-delete-dialog__btn confirm-delete-dialog__btn--delete">Удалить</button>
        <button
          type="button"
          @click="visibleDropdown=false"
          class="btn--surface-dim confirm-delete-dialog__btn confirm-delete-dialog__btn--cancel">Отмена</button>
      </div>
    </div>
  </div>
</template>

<script>

export default {

  name: 'DeleteRowDialog',

  data () {
    return {
      visibleDropdown: false
    }
  },

  methods: {
    deleteConfirm () {
      this.$emit('delete-confirm')
    }
  }
}
</script>

<style lang="css" scoped>
</style>